var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useAppSelector } from "@/hooks/store";
import { useLazyGetModuleBuilderLayoutQuery, useSaveLayoutDetailMutation, } from "@/store/api";
import copy from "fast-copy";
function updateEtcFields(components, callback) {
    if (!Array.isArray(components)) {
        return;
    }
    components.forEach(function (component) {
        // Uniquement les champs
        if (component.type === "etc-field") {
            callback(component);
        }
        // Continuer à parcourir les enfants
        if (Array.isArray(component.components)) {
            updateEtcFields(component.components, callback);
        }
    });
}
function initializeDetailViewFields(layoutMeta, defaultFieldStyles) {
    var _a;
    var newLayout = copy(layoutMeta);
    if (!((_a = newLayout === null || newLayout === void 0 ? void 0 : newLayout.layout) === null || _a === void 0 ? void 0 : _a.components)) {
        console.warn("Layout components absent", newLayout);
        return newLayout;
    }
    updateEtcFields(newLayout.layout.components, function (field) {
        var _a, _b;
        field.settings = field.settings || {};
        var flagCustom = field.settings.flag_custom;
        // Champ personnalisé : on garde ses valeurs
        if (flagCustom === "1") {
            return;
        }
        // Champ non personnalisé ou non initialisé :
        // on applique les valeurs du thème
        field.settings.flag_custom = "0";
        field.settings.styles = __assign(__assign({}, field.settings.styles), { color: __assign(__assign({}, (_a = field.settings.styles) === null || _a === void 0 ? void 0 : _a.color), { label: defaultFieldStyles.label_color, background: defaultFieldStyles.background_color, border: defaultFieldStyles.border_color }), spacing: __assign(__assign({}, (_b = field.settings.styles) === null || _b === void 0 ? void 0 : _b.spacing), { padding: {
                    top: defaultFieldStyles.pt,
                    right: defaultFieldStyles.pr,
                    bottom: defaultFieldStyles.pb,
                    left: defaultFieldStyles.pl,
                }, margin: {
                    top: defaultFieldStyles.mt,
                    right: defaultFieldStyles.mr,
                    bottom: defaultFieldStyles.mb,
                    left: defaultFieldStyles.ml,
                } }) });
    });
    return newLayout;
}
export function useDefaultSettingsDetailViewFields() {
    var _this = this;
    var _a;
    var packages_list = useAppSelector(function (state) { return state.moduleBuilder.studio_packages; });
    var fieldName = "detailviewdefs";
    var modules = Object.values(((_a = packages_list === null || packages_list === void 0 ? void 0 : packages_list.default) === null || _a === void 0 ? void 0 : _a.modules) || {}).map(function (item) { return item.module; });
    var getModuleBuilderLayout = useLazyGetModuleBuilderLayoutQuery()[0];
    var saveSaveLayoutDetailMutation = useSaveLayoutDetailMutation()[0];
    var saveDefaultDetailViewFields = function (detailViewFieldsSettings) { return __awaiter(_this, void 0, void 0, function () {
        var _i, modules_1, moduleName, viewDefs, layoutMeta, updatedLayout, payload, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _i = 0, modules_1 = modules;
                    _a.label = 1;
                case 1:
                    if (!(_i < modules_1.length)) return [3 /*break*/, 7];
                    moduleName = modules_1[_i];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, getModuleBuilderLayout({
                            moduleName: moduleName,
                            layout: fieldName,
                        }).unwrap()];
                case 3:
                    viewDefs = _a.sent();
                    layoutMeta = viewDefs.data.layout;
                    updatedLayout = initializeDetailViewFields(layoutMeta, detailViewFieldsSettings);
                    payload = {
                        moduleName: moduleName,
                        layoutName: fieldName,
                        body: {
                            content: updatedLayout,
                            publish: true,
                        },
                    };
                    return [4 /*yield*/, saveSaveLayoutDetailMutation({
                            moduleName: moduleName,
                            layoutName: fieldName,
                            body: {
                                content: updatedLayout,
                                publish: true,
                            },
                        }).unwrap()];
                case 4:
                    result = _a.sent();
                    console.log("".concat(moduleName, " detailviewdefs updated"));
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error("Erreur update ".concat(moduleName), error_1);
                    return [3 /*break*/, 6];
                case 6:
                    _i++;
                    return [3 /*break*/, 1];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return {
        saveDefaultDetailViewFields: saveDefaultDetailViewFields,
    };
}
